import { Injectable } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { ContractDetailsService } from '../contract-details.service';
import { PartnerService } from '../partner.service';
import { BillingFeatures, PartnerBillingInfo } from './billing-feature.interface';

@Injectable({ providedIn: 'root' })
export class BillingFeatureService {
  private partner$: Observable<PartnerBillingInfo>;

  constructor(
    private appConfig: AppConfigService,
    private partnerService: PartnerService,
    private contractDetailsService: ContractDetailsService,
  ) {
    this.partner$ = this.appConfig.config$.pipe(
      map((config) => config.partnerId),
      switchMap((partnerId) => this.partnerService.getPartnerByPartnerId(partnerId)),
      map((partnerData) => {
        return { id: partnerData.pid, stripeBilling: partnerData.stripe_billing };
      }),
    );
  }

  isSuperadminOrImpersonated(): boolean {
    return this.appConfig.config.isSuperAdmin || this.appConfig.config.isImpersonated;
  }

  features(): Observable<BillingFeatures> {
    return zip(this.showStripeBillingFeatures(), this.showVerifiedContractBillingFeatures()).pipe(
      map(([stripe, verified]) => {
        return { stripe, verified };
      }),
    );
  }

  showVerifiedContractBillingFeatures(): Observable<boolean> {
    return this.contractDetailsService.contractVerified.pipe(
      map((verified) => verified || this.isSuperadminOrImpersonated()),
    );
  }

  showStripeBillingFeatures(): Observable<boolean> {
    return this.partner$.pipe(
      map((partner) => {
        return partner.stripeBilling;
      }),
    );
  }
}
